/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState } from "react";
import "./style.css";
import { Props } from "../../model/application/props";
import { Button, Drawer, Dropdown, Menu, MenuProps } from "antd";
import logo from "../../images/logo.png";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../model/application/state";
import { useEffect } from "react";
import { UtilityConfig } from "../../service/action/utility";
import {
  RegistrationPage,
  UserAuthentication,
} from "../../service/action/merchant";
import { MenuItems } from "../../service/api/mock";
import SessionTimeout from "../component/sessionTimeout";
import { Logout } from "../component/logout-modal";
import DropDowns from "../../images/dropdown.svg";
import { FiMenu } from "react-icons/fi";
import {
  LogoutOutlined,
} from "@ant-design/icons";

export const MerchantLayoutContainer: React.FC<Props.LayoutPros> = (
  Props: Props.LayoutPros
) => {
  const dispatch = useDispatch();
  const { merchantsRegistrationState, utilityState }: any = useSelector(
    (state) => state
  );
  const state: State.UserValidation = merchantsRegistrationState;
  const config: State.Config = utilityState;
  const validateUser = useCallback(
    (state: State.UserValidation) => {
      dispatch({
        type: RegistrationPage.Logged_In_User,
        payload: {
          ...state,
        },
      });
    },
    [state]
  );

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!sessionStorage.getItem("*****")) {
      window.location.href = "/";
    } else {
      validateUser(state);
    }
  }, []);

  const LogoutFunc = useCallback(
    (state: State.Config) => {
      dispatch({
        type: UtilityConfig.Logout,
        payload: {
          ...state,
        },
      });
    },
    [state]
  );

  const Cancel = useCallback(() => {
    dispatch({
      type: UtilityConfig.Set_Utility_Config_State,
      payload: {
        ...state,
        logoutConfirmation: false,
      },
    });
  }, [state]);

  const logout = useCallback(() => {
    dispatch({
      type: UtilityConfig.Set_Utility_Config_State,
      payload: {
        ...config,
        logoutConfirmation: true,
        message: "Click Yes to proceed",
        title: "Are you sure you want to Logout?",
        okText: "Yes",
        cancelText: "No",
        onOk: () => {
          LogoutFunc(config);
        },
        onCancel: () => {
          Cancel();
        },
      },
    });
  }, []);

  const MenuClicked = useCallback(
    (e: any) => {
      dispatch({
        type: UserAuthentication.SET_USER_AUTHENTICATION,
        payload: {
          ...state,
          key: e.key,
        },
      });
    },
    [state]
  );

  const items: MenuProps["items"] = [
    {
      key: "1",
      label: (
        <div className="w-[15rem] flex flex-col items-center px-5 mt-7">
          <div className="">
            <div className="w-[5rem] h-[5rem] mx-auto grid mb-5 place-content-center text-3xl rounded-full bg-[#E6F1E6] text-[#006E01] font-semibold">
              {state.response?.firstName?.charAt(0).toUpperCase() +
                state.response?.lastName?.charAt(0).toUpperCase()!}
            </div>

            <h1 className="text-center font-bold text-md">{`${state.response?.firstName}  ${state.response?.lastName}`}</h1>
            <h2 className="text-center font-bold text-sm">
              Role:{" "}
              <span className="text-[#c4c4c4]">
                {state.response?.role?.name}
              </span>
            </h2>
            <hr className="border-[#c4c4c4] w-[13rem] my-5 mx-auto" />
            <div className="flex gap-2 font-semibold my-5">
              <p className="text-[0.8rem] flex items-center gap-3">
                WEB:{" "}
                <b
                  className={
                    !state.response?.merchant?.webDisabled
                      ? "text-primary-color"
                      : "text-primary-red"
                  }
                >
                  {!state.response?.merchant?.webDisabled ? (
                    <p className="flex items-center gap-1">
                      Enabled
                    </p>
                  ) : (
                    <p>
                      Disabled
                    </p>
                  )}
                </b>
              </p>
              <p className="text-[0.8rem] flex items-center gap-3">
                API:{" "}
                <b
                  className={
                    !state.response?.merchant?.disabled
                      ? "text-primary-color"
                      : "text-primary-red"
                  }
                >
                  {!state.response?.merchant?.disabled ? (
                    <p className="flex items-center gap-1">
                      Enabled
                    </p>
                  ) : (
                    <p>
                      Disabled
                    </p>
                  )}
                </b>
              </p>
            </div>
            <p className="text-center">{state.response?.phoneNumber}</p>
            <Button
              type="primary"
              onClick={logout}
              className="bg-[#FDDADA!important] mb-5 border-[#FAC1C1!important] hover:border-[#FAC1C1!important] mx-auto rounded-md text-[#ED0A0A!important] hover:text-[#ED0A0A!important] hover:bg-[#FAC1C1!important] flex items-center justify-center mt-5 py-5"
              icon={<LogoutOutlined rev={undefined} />}
              block
            >
              Logout
            </Button>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="h-[100svh] grid lg:grid-cols-1 grid-cols-[13rem_1fr]">
      <SessionTimeout />
      <Logout />
      <nav className="shadow-sm z-10 block lg:hidden overflow-auto">
        <div className="mb-10">
          <img
            src={logo}
            className="-my-[4rem] w-full mx-auto"
            style={{ width: 190, height: 220 }}
            alt="logo"
          />
          <h1 className="text-center text-primary-color font-bold text-lg -mt-5">
            BILLER SERVICES
          </h1>
          <div className="mt-5 -mb-5 text-center text-sm">
            Merchant ID: <br /> <b>{state.response?.merchant?.merchantId}</b>
          </div>
        </div>
        <Menu
          className="side-menu"
          theme="light"
          mode="inline"
          selectedKeys={[Props.defaultSelectedKeys as string]}
          items={
            state.response?.merchant?.webDisabled
              ? MenuItems.filter((x) => x.key !== "180" && x.key !== "280")
              : MenuItems
          }
          onClick={(e) => MenuClicked(e)}
        />
        <Drawer
          open={visible}
          onClose={() => setVisible(!visible)}
          placement="left"
          width={"70%"}
          headerStyle={{display: "none"}}
        >
          <div className="mb-10">
            <img
              src={logo}
              className="-my-[4.5rem] w-full mx-auto"
              style={{ width: 190, height: 220 }}
              alt="logo"
            />
            <h1 className="text-center text-primary-color font-bold text-lg -mt-5">
              BILLER SERVICES
            </h1>
            <div className="mt-5 -mb-5 text-center text-sm">
              Merchant ID: <br /> <b>{state.response?.merchant?.merchantId}</b>
            </div>
          </div>
          <Menu
            className="side-menu"
            theme="light"
            mode="inline"
            selectedKeys={[Props.defaultSelectedKeys as string]}
            items={
              state.response?.merchant?.webDisabled
                ? MenuItems.filter((x) => x.key !== "180" && x.key !== "280")
                : MenuItems
            }
            onClick={(e) => MenuClicked(e)}
          />
          <p
            onClick={logout}
            className="text-primary-red font-bold flex items-center gap-2 justify-center"
          >
            Logout <LogoutOutlined rev={undefined} />
          </p>
        </Drawer>
      </nav>
      <main className="grid grid-rows-[4.5rem_1fr] sm:grid-rows-[4rem_1fr] overflow-auto">
        <header className="shadow-sm z-10 flex justify-between items-center md:px-3 px-10">
          <div className="hidden items-center lg:flex gap-3">
            <img
              src={logo}
              className="-my-[4rem] -mx-[2rem]"
              style={{ width: 150, height: 150 }}
              alt="logo"
            />
            <h1 className="font-bold text-xl">{Props.pageTitle}</h1>
          </div>
          <h1 className="font-bold text-xl block lg:hidden">
            {Props.pageTitle}
          </h1>
            {
              state.response &&
          <div className="lg:hidden flex items-center gap-3">
            <span className="w-[3rem] h-[3rem] flex items-center justify-center rounded-full text-xl bg-[#DDEEDD] font-bold">
              <h2 className="font-medium text-primary-color">
                {state?.response?.firstName?.charAt(0).toUpperCase()}
                {state?.response?.lastName?.charAt(0).toUpperCase()}
              </h2>
            </span>
            <div className="font-bold grid place-content-center">
              <h2>{`${state.response?.firstName} ${state.response?.lastName}`}</h2>
              <p className=" text-[gray] font-light">
                {state.response?.role?.name}
              </p>
            </div>
            <Dropdown trigger={["click"]} menu={{ items }}>
              <img
                src={DropDowns}
                alt="dropdown"
                className="lg:hidden cursor-pointer block"
              />
            </Dropdown>
          </div>
            }
          <FiMenu
            className="lg:block hidden text-2xl"
            onClick={() => setVisible(!visible)}
          />
        </header>
        <section className="md:px-3 px-5 bg-[#F5F6FA] overflow-auto">
          {Props.children}
        </section>
         <footer className="text-center flex items-center justify-center w-full mx-auto py-5">
      <img src="https://sso.xpresspayments.com:25018/static/media/cbn.561775efab2fb75c3148efd434532c5d.svg" alt="" className="w-[40%]" />
    </footer>
      </main>
     
    </div>
  );
};
